import React, { useState } from 'react';
import "./App.css";
import { Navbar } from './components/Navbar';
import { HeroSlider } from './components/HeroSlider';
import { AboutSection } from './components/AboutSection';
import { RestaurantMenu } from './components/RestaurantMenu';
import { ContactSection } from './components/ContactSection';
import { ConsentBanner } from './components/ConsentBanner';
import { Toaster } from './components/ui/sonner';

function App() {
  const [lang, setLangState] = useState(() => localStorage.getItem('site_lang') || 'fi');

  const setLang = (val) => {
    setLangState(val);
    localStorage.setItem('site_lang', val);
  };

  return (
    <div className="App bg-black min-h-screen font-sans selection:bg-red-600 selection:text-white">
      <Navbar lang={lang} setLang={setLang} />
      
      <main>
        <HeroSlider lang={lang} />
        <AboutSection lang={lang} />
        <RestaurantMenu lang={lang} />
      </main>

      <ContactSection lang={lang} />
      <ConsentBanner lang={lang} />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
